import { getBetTitleSystemBetProps, getBetStatusLabelProps, getSelectionTitlesListProps, getBonusDetailsListProps, getTotalReturnProps, getSelectionDetailsListProps, isBonusAvailable, getBetSummarySystemBetProps } from "../bet";
export const getSystemBetProps = (bet, state) => {
    const props = {
        betTitle: getBetTitleSystemBetProps(bet, state),
        betStatusLabel: getBetStatusLabelProps(bet, state),
        selectionTitlesList: getSelectionTitlesListProps(bet, state),
        totalReturn: getTotalReturnProps(bet, state),
        selectionDetailsList: getSelectionDetailsListProps(bet, state),
        betSummary: getBetSummarySystemBetProps(bet, state)
    };
    if (isBonusAvailable(bet)) {
        props.bonusDetailsList = getBonusDetailsListProps(bet, state);
    }
    return props;
};
//# sourceMappingURL=getSystemBetProps.js.map